import React, { useEffect, useState } from 'react'
import { BiHomeAlt } from 'react-icons/bi';
import { MdKeyboardArrowRight, MdSearch } from 'react-icons/md';
import Loader from '../../../../Components/loader/loader';
import Header from '../../../../Components/Dashboard/Header/Header';
import Sidebar from '../../../../Components/Dashboard/Sidebar/Sidebar';
import { Apiurl, GetToken } from '../../../../Utils/utils';
import axios from 'axios';
import "./ViewTask.css"
import { toast } from 'react-toastify';
import { FaArrowDown } from 'react-icons/fa';

const ViewTask = () => {
    const [loading, setLoading] = useState(false);
    const [showSidebar, setShowSidebar] = useState(true);
    const [ViewAlluserTask,setViewAlluserTask]=useState([])
    const [ButtonChange,setButtonChange]=useState(false)
    console.log(ViewAlluserTask,"ViewAlluserTask");
    const [ViewAlluserTaskDuplicate,setViewAlluserTaskDuplicate]=useState([])

    const [TaskId,setTaskId]=useState('')
    console.log(TaskId,"TaskIdTaskId222222");
    const LoginToken = GetToken();

    const handleDataSearch = (e) => {
      const searchData = e?.target?.value;
      if (searchData) {
        const filterData = ViewAlluserTask?.filter((item) =>
          item?.ReportToUser?.UserName?.toLowerCase()?.includes(searchData)
        );
        setViewAlluserTask(filterData);
      } else {
        setViewAlluserTask(ViewAlluserTaskDuplicate);
      }
    };

    const handleProjectData = () => {
        setLoading(true);
        const options = {
          method: "GET",
          headers: {
            "access-control-allow-origin": "*", 
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },
          url:`${Apiurl()}/Task/GetAssignedTasksToUser`,
        };
    
        axios(options)
          .then((response) => {
            setLoading(false);
            if (response.status === 200) {
              const responseData = response.data;
              const data = JSON.parse(response?.data?.data);
              console.log(data,"datadata");
              // const findTaskId = data.map((item)=>item)
              // console.log(findTaskId,"findTaskId");
              // setTaskId(findTaskId)
              setViewAlluserTask(data)
              setViewAlluserTaskDuplicate(data)
                
            }
          })
          .catch((error) => {
            setLoading(false);
            console.error("Error fetching client data:", error);
          });
      };        
      useEffect(()=>{
        handleProjectData()
      },[])

      const StartTask = (item) => {
        setLoading(true);
        // const data = {
        //   TaskId: TaskId.Id
        // };
        const data = {}
        data.TaskId = item.Id

      
        const option = {
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },  
          url:`${Apiurl()}/Task/StartTaskForUser`,
          data: { data: JSON.stringify(data) },

        };
        axios(option)
          .then((e) => {
            setLoading(false);
            if (e?.status === 200) {
              toast.success(e?.data?.message);
              handleProjectData()
            }
          })
          .catch((error) => {
            setLoading(false);
          });
      };
      const PauseTask = (item) => {
        setLoading(true);
        // const data = {
        //   TaskId: TaskId.Id
        // };
      const data ={}
      data.TaskId = item.Id
        const option = {
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },  
          url:`${Apiurl()}/Task/PauseTask`,
          data: { data: JSON.stringify(data) },

        };
        axios(option)
          .then((e) => {
            setLoading(false);
            if (e?.status === 200) {
              toast.success(e?.data?.message);
              setTaskId()
              handleProjectData()
            }
          })
          .catch((error) => {
            setLoading(false);
          });
      };
      const TaskCompleted = (item) => {
        setLoading(true);
       const data={}
       data.TaskId = item.Id
        const option = {
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "content-type": "application/json",
            authorization: `Bearer ${LoginToken}`,
          },  
          url:`${Apiurl()}/Task/TaskCompleted`,
          data: { data: JSON.stringify(data) },

        };
        axios(option)
          .then((e) => {
            setLoading(false);
            if (e?.status === 200) {
              toast.success(e?.data?.message);
            }
          })
          .catch((error) => {
            setLoading(false);
          });
      };
  const handelToggel= (item) => {
    setTaskId(item)
    console.log(item,"itemitem");
    if (!item.UserStatus || item.UserStatus === "Paused") {
      StartTask(item)
    } 
    if (item.UserStatus === "Started") {
      PauseTask(item)
      
    }
  }
  return (
    <>
    {loading ? <Loader /> : null}
    <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
    <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
            <div
                className={
                    showSidebar
                        ? "main-container-of-all-employees-Attendance-Holiday"
                        : "main-container-of-all-employees-page-new-Attendance-management"
                }
            >
                <div className="inner-container-of-all-employees-page-Holiday ">
                    <div className="header-of-employees-page-Holiday row">
                        <div className="all-employee-Attendance-Holiday col">
                            <h4>Task</h4>
                        </div>
                        <div className="all-employees-Attendance-Holiday col">
                            <div className="home-icon-Attendance-Holiday">
                                <BiHomeAlt className="home-icon-header-Attendance-Holiday" />
                            </div>
                            <div className="arrow-icon-Attendance-Holiday">
                                <MdKeyboardArrowRight />
                            </div>
                            <div className="employee-text-Attendance-Holiday">
                                <p>Task </p>
                            </div>
                            <div className="arrow-icon-Attendance-Holiday">
                                <MdKeyboardArrowRight />
                            </div>
                            <div className="all-employee-text-Attendance-Holiday">
                                <p>View Task </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="body-part-outer-Attendance-Holiday">
                    <div className="inner-body-container-of-employee-Attendance-Holiday row-12">
                        <div className=" first-side-in-body-Attendance-Holiday col-6">
                            <div className="employee-text-in-Attendance-Holiday">
                                <h2>Task</h2>
                            </div>
                            <div className="input-for-search-in-employee-Attendance-Holiday">
                                <MdSearch className="search-icon-in-Attendance-Holiday" />
                                <input
                                    type="text"
                                    placeholder="Search"
                                    onChange={(e) => handleDataSearch(e)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className= {ViewAlluserTask.length?"table-in-all-emplyee-Attendance-Holiday" :"Nodataavailable" }>
                    {ViewAlluserTask && ViewAlluserTask.length > 0 ? (

                        <table className="table-main-Attendance-Holiday">
                            <thead className="thead-main-Attendance-Holiday">
                                <tr className="row-12">
                                    <th className="image-class-Holiday col-2 ">
                                        Sr. no
                                    </th>
                                    <th className="image-class-Holiday col-2 ">
                                         Assigned  By
                                    </th>
                                    <th className="image-class-Holiday col-2 ">Title</th>
                                    <th className="image-class-Holiday col-2 ">Description</th>
                                    <th className="image-class-Holiday col-2 ">Document</th>
                                    <th className="image-class-Holiday col-2 ">Action</th>
                                </tr>
                            </thead>

                            <tbody className="tbody-main-Attendance-Holiday">
                                
                                {ViewAlluserTask?.sort((a, b) => a.UserName?.localeCompare(b.UserName))?.map((item, index) => {
                                  return(
                                    <tr key={index}>
                                    <>
                                        <td>{index + 1}</td>
                                        <td> {item?.ReportToUser?.UserName}</td>
                                        <td> {item?.Task?.Title}</td>
                                        <td> {item?.Task?.Description}</td>
                                        <td>
<a href={item?.UrlLink} target="_blank" download _blank>
<FaArrowDown />
</a>
</td>
                                        <td>
                                        { 
item.Task.UserStatus === null || item.Task.UserStatus === 'Paused'   ? 
<button className='Task-start-button' onClick={() => handelToggel(item.Task)}>Start</button> :
item.Task.UserStatus === 'Started' ?
  <button className='PauseTask-button' onClick={() => handelToggel(item.Task)}>Pause</button> :
  null
}                                    
                                  <button onClick={()=>TaskCompleted(item.Task)} className='Task-Completed-button'>Complete</button> 
                                        </td> 
                                    </>
                                </tr>   
                                  )
                                }
                                  
                           
                                )}  

                            </tbody>

                        </table>
                        ) : (
                            <div>
                                <p>No data available</p>
                            </div>
                          )}
                    </div>
                </div>
            </div>
        </>
    </div>


   
    
</>
  )
}

export default ViewTask